import Vue from "vue";
import { Component } from "vue-property-decorator";

const InfoModalProps = Vue.extend({
  props: {
    titleText: {
      type: String,
      required: true,
    },
    contentText: {
      type: String,
      required: true,
    },
    buttonLabel: {
      type: String,
    },
    internalError: {
      type: Boolean,
    },
    closeIcon: {
      type: String,
      default: require("@/assets/icons/icon_close.svg"),
    },
  },
});

@Component({
  name: "InfoModal",
})
export default class InfoModal extends InfoModalProps {
  $refs!: {
    modal: any;
  };

  emitEvent() {
    this.$emit('infoModalButtonEvent');
  }
}
